import { render, staticRenderFns } from "./Comunicacao.vue?vue&type=template&id=4e4eb166&"
import script from "./Comunicacao.vue?vue&type=script&lang=js&"
export * from "./Comunicacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports